import Employee from './Employee'
export class SaveEmployeeRequest {
    Employee: Employee;
    SavedByEmployee: Employee;
}

export default SaveEmployeeRequest;